<form [formGroup]="customersForm" (ngSubmit)="onSubmit()">
	<h1>Admin login as customer</h1>
	<app-select-field label="Select customer" [control]="customersForm.get('customer')" name="customers"
		[options]="customerList$ | async">
	</app-select-field>
	<div class="login-actions">
		<mat-spinner *ngIf="loading" diameter="20"></mat-spinner>
		<button type="submit" mat-flat-button color="primary" [disabled]="customersForm.invalid">Continue</button>
	</div>
</form>